import * as React from "react";

import { All } from "./All";
import { QuestionnaireDetails } from "./QuestionnaireDetails";
import { QuestionnaireEdit } from "./QuestionnaireEdit";
import { CreateAdditionalQuestionFormModal } from "./CreateAdditionalQuestionFormModal";

import { Fragment, Location } from "redux-little-router";

export const Base: React.FunctionComponent = () => (
    <div className="questionnaire-config">
        <Fragment forRoute="/" withConditions={isNotASpecificQuestionnaireTypeRoute}>
            <All />
        </Fragment>
        <Fragment forRoute="/:questionnaireType">
            <>
                <Fragment forRoute="/edit">
                    <QuestionnaireEdit />
                </Fragment>
                <Fragment forRoute="/">
                    <>
                        <QuestionnaireDetails />
                        <CreateAdditionalQuestionFormModal />
                    </>
                </Fragment>
            </>
        </Fragment>
    </div>
);

const isNotASpecificQuestionnaireTypeRoute = (l: Location) => !l.params.questionnaireType;
